export default {
  data() {
    return {
      sheet_version: ['', '']
    }
  },
  methods: {
    sheet_url(page) {
      const names = {
        1: 'version',
        2: 'birdlist v2020',
        3: 'famliy v2020',
        4: 'bbs bird list',
        5: 'plot',
        6: 'plot history'
      }
      const workbookid = '1S3ARsmpH0Ml1-2QmqkI_KPqcgp-CnyN9qkzxxr78U74'
      const apikey = 'AIzaSyAPs282cs1sZiPCabEYuojj9QSpVdLqP_0'
      const name = encodeURIComponent(names[page])
      return `https://sheets.googleapis.com/v4/spreadsheets/${workbookid}/values/${name}?alt=json&key=${apikey}`
      //return `https://spreadsheets.google.com/feeds/list/1S3ARsmpH0Ml1-2QmqkI_KPqcgp-CnyN9qkzxxr78U74/${index}/public/full?alt=json`
    },
    sheet_format(values) {
      const names = values.shift()
      //console.log(names)
      return values.map(item => {
        let data = {}
        for (let i = 0; i < names.length; i++) {
          data[names[i]] = item[i] || ''
        }
        return data
      })
    },
    array2object(items) {
      const ret = items.reduce((result, item) => {
        const key = Object.keys(item)[0]
        result[key] = item[key]
        return result
      })
      return ret
    },
    async update_version() {
      this.sheet_version[0] = this.$offlineStorage.get('version')
      try {
        const ret = await this.$http(this.sheet_url(1))
        this.sheet_version[1] = ret.data.values[1][0]
      } catch (err) {
        console.log(err)
      }
    },
    async update_bird_list() {
      try {
        const ret = await this.$http.get(this.sheet_url(2))
        const data = this.sheet_format(ret.data.values)
        const birds = this.array2object(
          data.map(item => ({
            [item.cname]: {
              e: item.ename,
              f: parseInt(item.fid),
              i: parseInt(item.id),
              sn: item.sname,
              es: item.shortname.split(',')
            }
          }))
        )
        this.$offlineStorage.set('tw_birds', birds)
      } catch (err) {
        console.log(err)
      }
    },
    async update_family_list() {
      try {
        const ret = await this.$http.get(this.sheet_url(3))
        const data = this.sheet_format(ret.data.values)
        const familys = this.array2object(
          data.map(item => ({
            [item.name]: parseInt(item.fid)
          }))
        )
        this.$offlineStorage.set('tw_familys', familys)
      } catch (err) {
        console.log(err)
      }
    },
    async update_bbs_birds() {
      console.log('')
      try {
        const ret = await this.$http.get(this.sheet_url(4))
        const data = this.sheet_format(ret.data.values)
        const bbs_birds = this.array2object(
          data.map(item => ({
            [item.bbsname]: {
              cn: item.cname,
              en: item.ename,
              sn: item.sname,
              es: item.shortname.split(','),
              sortvalue: eval(item.sortvalue)
            }
          }))
        )
        this.$offlineStorage.set('bbs_birds', bbs_birds)
      } catch (err) {
        console.log(err)
      }
    },
    async update_bbs_plot() {
      try {
        const ret = await this.$http.get(this.sheet_url(5))
        const data = this.sheet_format(ret.data.values)
        let plots = {}
        for (const item of data) {
          if (!Object.prototype.hasOwnProperty.call(plots, item.樣區編號)) {
            plots[item.樣區編號] = {
              name: item.樣區名稱,
              city: item.縣市,
              plotdtl: new Array()
            }
          }
          plots[item.樣區編號]['plotdtl'].push({
            id: item.樣區樣點編號,
            pno: parseInt(item.樣點代號),
            lng: item['X_經度(度分秒)'],
            lat: item['Y_緯度(度分秒)']
          })
        }
        this.$offlineStorage.set('plots', plots)
      } catch (err) {
        console.log(err)
      }
    },
    async update_bbs_history_birds() {
      try {
        const ret = await this.$http.get(this.sheet_url(6))
        const data = this.sheet_format(ret.data.values)
        const plot_birds = this.array2object(
          data.map(item => ({
            [item.pid]: item.bird.split(',').map(item => parseInt(item))
          }))
        )
        this.$offlineStorage.set('plot_birds', plot_birds)
      } catch (err) {
        console.log(err)
      }
    }
  }
}
